export const REPORT_TYPES = {
  CONTACTS_CREATED: 'CONTACTS_CREATED',
  CONTACTS_ASSIGNED: 'CONTACTS_ASSIGNED',
  CONTACTS_WORKED: 'CONTACTS_WORKED',
  NEW_DEALS_CREATED: 'NEW_DEALS_CREATED',
  DEALS_CLOSED_WON: 'DEALS_CLOSED_WON'
};